// extracted by mini-css-extract-plugin
export default {"pre":"ComplaintFormWorktimeProductData-QsSfT__pre"};